import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';

const ManageIndividualBoards = ({ language, refs }) => {
    let boardMenu = [
        {
            id: 'tutorial.manageSplitBoardLesson.singleBoard.description',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.singleBoard.explanation1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.singleBoard.explanation2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/lessonPage_multiBoardSingle.jpeg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageSplitBoardLesson-singleBoard'}
            title={'tutorial.manageSplitBoardLesson.singleBoard.title'}
            explanations={boardMenu}
            imageTop={false}
        />
    );
};

export default ManageIndividualBoards;
